'use strict';

require('backbone.stickit');
const Mn = require('backbone.marionette');
const i18n = require('i18next');
const Template = require('communication/ui/template/task/state-edit.hbs');

module.exports = Mn.View.extend({
    template: Template,
    bindings: {
        'select.state': {
            observe: 'state',
            selectOptions: {
                collection: function() {
                    return _.map(this.model.getStateChoices(), s => {
                        return {
                            value: s,
                            label: i18n.t(`communication:task.state.${s}`)
                        }
                    });
                }
            }
        }
    },
    modelEvents: {
        'change': 'stateChange'
    },

    onRender: function() {
        this.stickit();
    },

    stateChange: function() {
        this.trigger('change:state');
    }
});



// WEBPACK FOOTER //
// ./communication/ui/view/task/state-edit.js